export { default } from "./back.svg";
